import axios  from "axios";
axios.defaults.baseURL = 'https://ysdtapi.cdssjj.changde.gov.cn';

export {axios};
